import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'app-xs-table-tooltip',
  templateUrl: './xs-table-tooltip.component.html',
  styleUrls: ['./xs-table-tooltip.component.scss'],
})
export class XsTableTooltipComponent implements OnInit {
  @Input() fecha: string;
  @Input() text: string;
  //
  showTooltip: boolean;
  //
  constructor() {}

  ngOnInit() {}
}
